import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemMailIncomingRoute: InvariantJiraRoute = {
	name: 'global-settings-system-mail-incoming',
	path: '/secure/admin/IncomingMailServers.jspa',
};
